<div class="cbb-select-wrapper">
  <label *ngIf="label" class="cbb-label">{{ label }}</label>
  <ng-select
    class="cbb-ng-select"
    [class.cbb-ng-select--invalid]="mensajeError"
    [items]="options"
    [bindLabel]="bindLabel"
    [bindValue]="normalizedBindValue"
    [placeholder]="placeholder"
    [clearable]="clearable"
    [searchable]="searchable"
    [multiple]="multiple"
    [closeOnSelect]="closeOnSelect"
    [loading]="loading"
    [disabled]="isDisabled || disabled"
    [notFoundText]="notFoundText"
    [appendTo]="appendTo"
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onModelChange($event)"
    (blur)="onBlur()"
  >
  </ng-select>
  <div class="cbb-error-msg" [class.cbb-error-msg--visible]="mensajeError">{{ mensajeError || '&nbsp;' }}</div>
</div>
